import { ReactComponent as Arrow } from './icons/arrow.svg';
import { ReactComponent as Bin } from './icons/bin.svg';
import { ReactComponent as Book } from './icons/book.svg';
import { ReactComponent as Camera } from './icons/camera.svg';
import { ReactComponent as Chat } from './icons/chat.svg';
import { ReactComponent as Check } from './icons/check.svg';
import { ReactComponent as Chevron } from './icons/chevron.svg';
import { ReactComponent as Copy } from './icons/copy.svg';
import { ReactComponent as Dots } from './icons/dots.svg';
import { ReactComponent as Download } from './icons/download.svg';
import { ReactComponent as Edit } from './icons/edit.svg';
import { ReactComponent as Exclamation } from './icons/exclamation.svg';
import { ReactComponent as External } from './icons/external.svg';
import { ReactComponent as EyeClosed } from './icons/eye-closed.svg';
import { ReactComponent as Eye } from './icons/eye.svg';
import { ReactComponent as Filter } from './icons/filter.svg';
import { ReactComponent as Heart } from './icons/heart.svg';
import { ReactComponent as Info } from './icons/info.svg';
import { ReactComponent as Instagram } from './icons/instagram.svg';
import { ReactComponent as Link } from './icons/link.svg';
import { ReactComponent as LinkedIn } from './icons/linkedin.svg';
import { ReactComponent as List } from './icons/list.svg';
import { ReactComponent as Location } from './icons/location.svg';
import { ReactComponent as Lock } from './icons/lock.svg';
import { ReactComponent as Medium } from './icons/medium.svg';
import { ReactComponent as MessageError } from './icons/message-error.svg';
import { ReactComponent as MessageSuccess } from './icons/message-success.svg';
import { ReactComponent as MessageWarning } from './icons/message-warning.svg';
import { ReactComponent as Plus } from './icons/plus.svg';
import { ReactComponent as Search } from './icons/search.svg';
import { ReactComponent as Security } from './icons/security.svg';
import { ReactComponent as Settings } from './icons/settings.svg';
import { ReactComponent as Smile } from './icons/smile.svg';
import { ReactComponent as Star } from './icons/star.svg';
import { ReactComponent as Twitter } from './icons/twitter.svg';
import { ReactComponent as User } from './icons/user.svg';
import { ReactComponent as YouTube } from './icons/youtube.svg';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Icon: any = {
  Arrow,
  Bin,
  Book,
  Camera,
  Chat,
  Check,
  Chevron,
  Copy,
  Dots,
  Download,
  Edit,
  Exclamation,
  External,
  EyeClosed,
  Eye,
  Filter,
  Heart,
  Info,
  Instagram,
  Link,
  LinkedIn,
  List,
  Location,
  Lock,
  Medium,
  MessageError,
  MessageSuccess,
  MessageWarning,
  Plus,
  Search,
  Smile,
  Star,
  Twitter,
  Security,
  Settings,
  User,
  YouTube,
};
